// 动漫页面
import React, { useEffect, useContext, useState, useRef } from "react";
import { LikeOutlined, MessageOutlined, StarOutlined } from "@ant-design/icons";
import { Avatar, List, Space } from "antd";
import styles from "./index.less";
import { datas } from "./config";

const IconText = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);
const Cartoon = () => {
  return (
    <div className={styles["cartoon"]}>
      <List
        itemLayout="vertical"
        dataSource={datas}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            actions={[
              <IconText
                icon={StarOutlined}
                text={item.isend}
                key="list-vertical-star-o"
              />,
              <IconText
                icon={LikeOutlined}
                text={item.vv}
                key="list-vertical-like-o"
              />,
            ]}
            extra={
              <a target="blank" href={item.fun_h5_url}>
                <img width={274} alt="logo" src={item.avatar} />
              </a>
            }
          >
            <List.Item.Meta
              avatar={<Avatar src={item.avatar} />}
              title={
                <a target="blank" href={item.fun_h5_url}>
                  {item.name}
                </a>
              }
              description={item.description}
            />
            {item.content}
          </List.Item>
        )}
      />
    </div>
  );
};

export default Cartoon;
